import React from 'react';
import { RefreshCw } from 'react-feather';
import { Button, ButtonGroup } from 'components/ui';
import LinkButton from 'components/shared/LinkButton';

const ActionButtons = ({
  back,
  tryAgain,
  primaryAction,
  primaryActionText,
  icon,
}) => (
  <ButtonGroup alignEnd className="ElementAssistantModal-actionButtons mt-8">
    <LinkButton className="td-n mr-8" onClick={back}>
      {t('common.back')}
    </LinkButton>
    <Button onClick={tryAgain}>
      <RefreshCw fill="none" className="Icon Button-icon" />
      {t('lessons.editor.element_assistant.actions.try_again')}
    </Button>
    <Button customColor onClick={primaryAction}>
      {icon}
      {primaryActionText}
    </Button>
  </ButtonGroup>
);

export default ActionButtons;
